module.exports = __webpack_public_path__ + "img/modem-02.097710d8.svg";